<template>
  <div>
    <div>
      <show-agent-monthly-bill-order :product-stop-order="productStopOrder" />
    </div>
  </div>
</template>

<script>
import { findAgentProductStopOrder } from '@/api/agent_product_stop_order'

export default {
  name: 'ShowAgentMonthlyBillStop',
  components: {
    ShowAgentMonthlyBillOrder: () => import('@/views/agent_monthly_bills/stop/agency_self/show/Order')
  },
  data() {
    return {
      productStopOrder: {}
    }
  },
  computed: {
    productStopOrderId() {
      return parseInt(this.$route.params.stop_id)
    },

    billId() {
      return parseInt(this.$route.query.bill_id)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findAgentProductStopOrder(this.productStopOrderId).then((res) => {
        if (res.code === 0) {
          this.productStopOrder = res.data
          this.$store.dispatch('ConcatDynamicBreadCrumbs', [
            { redirect: `/monthly_bills`, meta: { title: '月账单' }},
            { redirect: `/monthly_bills/${this.billId}`, meta: { title: this.productStopOrder.month }},
            { redirect: ``, meta: { title: this.productStopOrder.agents_product_name }}
          ]
          ).then(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.bread-crumb {
  margin-bottom: 20px;
}
</style>
